/* tslint:disable */
/* eslint-disable */
/**
 * Role Requirements API
 * ap-southeast-2
 *
 * The version of the OpenAPI document: 1.0.dev
 * Contact: RoleReqs_DevTeam@seek.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import globalAxios, {
  type AxiosPromise,
  type AxiosInstance,
  type AxiosRequestConfig,
} from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common';
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
} from '../base';
// @ts-ignore
import { BatchResponseOfQuestionnaire } from '../models';
// @ts-ignore
import { CreateQuestionnaireRequest } from '../models';
// @ts-ignore
import { ProblemDetails } from '../models';
// @ts-ignore
import { PublishRequest } from '../models';
// @ts-ignore
import { PutQuestionsResponse } from '../models';
// @ts-ignore
import { Question } from '../models';
// @ts-ignore
import { Questionnaire } from '../models';
// @ts-ignore
import { SelectedRecommendationsRequest } from '../models';
/**
 * QuestionnairesApi - axios parameter creator
 * @export
 */
export const QuestionnairesApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @summary Creates a questionnaire
     * @param {CreateQuestionnaireRequest} createQuestionnaireRequest Required properties needed to construct the questionnaire
     * @param {boolean} [prefill] If true, the latest answers the hirer has previously used will be automatically selected
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    questionnairesCreateQuestionnaire: async (
      createQuestionnaireRequest: CreateQuestionnaireRequest,
      prefill?: boolean,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'createQuestionnaireRequest' is not null or undefined
      assertParamExists(
        'questionnairesCreateQuestionnaire',
        'createQuestionnaireRequest',
        createQuestionnaireRequest,
      );
      const localVarPath = `/questionnaires`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication s2sauth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (prefill !== undefined) {
        localVarQueryParameter['prefill'] = prefill;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createQuestionnaireRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Gets a questionnaire
     * @param {string} id The unique id for a questionnaire
     * @param {boolean} [prefill]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    questionnairesGetQuestionnaire: async (
      id: string,
      prefill?: boolean,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('questionnairesGetQuestionnaire', 'id', id);
      const localVarPath = `/questionnaires/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication s2sauth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (prefill !== undefined) {
        localVarQueryParameter['prefill'] = prefill;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get a list of questionnaires
     * @param {string} questionnaireIds Comma-delimited list of questionnaire IDs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    questionnairesGetQuestionnaires: async (
      questionnaireIds: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'questionnaireIds' is not null or undefined
      assertParamExists(
        'questionnairesGetQuestionnaires',
        'questionnaireIds',
        questionnaireIds,
      );
      const localVarPath = `/questionnaires`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication s2sauth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (questionnaireIds !== undefined) {
        localVarQueryParameter['questionnaireIds'] = questionnaireIds;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Gets a questionnaire\'s questions
     * @param {string} id The unique id for a questionnaire
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    questionnairesGetQuestions: async (
      id: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('questionnairesGetQuestions', 'id', id);
      const localVarPath = `/questionnaires/{id}/questions`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication s2sauth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Save a questionnaire
     * @param {string} questionnaireId The unique id for a questionnaire being saved
     * @param {SelectedRecommendationsRequest} selectedRecommendationsRequest The selected questions
     * @param {string} [ifMatch] The current version of this questionnaire
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    questionnairesUpdateQuestionnaire: async (
      questionnaireId: string,
      selectedRecommendationsRequest: SelectedRecommendationsRequest,
      ifMatch?: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'questionnaireId' is not null or undefined
      assertParamExists(
        'questionnairesUpdateQuestionnaire',
        'questionnaireId',
        questionnaireId,
      );
      // verify required parameter 'selectedRecommendationsRequest' is not null or undefined
      assertParamExists(
        'questionnairesUpdateQuestionnaire',
        'selectedRecommendationsRequest',
        selectedRecommendationsRequest,
      );
      const localVarPath =
        `/questionnaires/{questionnaireId}/questions`.replace(
          `{${'questionnaireId'}}`,
          encodeURIComponent(String(questionnaireId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'PUT',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication s2sauth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (ifMatch !== undefined && ifMatch !== null) {
        localVarHeaderParameter['If-Match'] = String(ifMatch);
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        selectedRecommendationsRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * You may call this endpoint as many times as you like; it is idempotent. Once in a published state, the questionnaire is locked from further change and cannot be \'un-published\'. This call must be made irrespective if the questionnaire is being attached or not. The response code of this call will indicate whether or not the hirer has chosen any questions to attach to their job advertisement. Both response codes (303 and 204) mean the request to publish was successful.
     * @summary Update Questionnaire to published state
     * @param {string} id The unique id for the Questionnaire being updated
     * @param {PublishRequest} publishRequest The publish request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    questionnairesUpdateQuestionnaireState: async (
      id: string,
      publishRequest: PublishRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('questionnairesUpdateQuestionnaireState', 'id', id);
      // verify required parameter 'publishRequest' is not null or undefined
      assertParamExists(
        'questionnairesUpdateQuestionnaireState',
        'publishRequest',
        publishRequest,
      );
      const localVarPath = `/questionnaires/{id}/state`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'PUT',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication s2sauth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        publishRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * QuestionnairesApi - functional programming interface
 * @export
 */
export const QuestionnairesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    QuestionnairesApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Creates a questionnaire
     * @param {CreateQuestionnaireRequest} createQuestionnaireRequest Required properties needed to construct the questionnaire
     * @param {boolean} [prefill] If true, the latest answers the hirer has previously used will be automatically selected
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async questionnairesCreateQuestionnaire(
      createQuestionnaireRequest: CreateQuestionnaireRequest,
      prefill?: boolean,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Questionnaire>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.questionnairesCreateQuestionnaire(
          createQuestionnaireRequest,
          prefill,
          options,
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     *
     * @summary Gets a questionnaire
     * @param {string} id The unique id for a questionnaire
     * @param {boolean} [prefill]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async questionnairesGetQuestionnaire(
      id: string,
      prefill?: boolean,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Questionnaire>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.questionnairesGetQuestionnaire(
          id,
          prefill,
          options,
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     *
     * @summary Get a list of questionnaires
     * @param {string} questionnaireIds Comma-delimited list of questionnaire IDs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async questionnairesGetQuestionnaires(
      questionnaireIds: string,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<BatchResponseOfQuestionnaire>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.questionnairesGetQuestionnaires(
          questionnaireIds,
          options,
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     *
     * @summary Gets a questionnaire\'s questions
     * @param {string} id The unique id for a questionnaire
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async questionnairesGetQuestions(
      id: string,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<Question>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.questionnairesGetQuestions(id, options);
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     *
     * @summary Save a questionnaire
     * @param {string} questionnaireId The unique id for a questionnaire being saved
     * @param {SelectedRecommendationsRequest} selectedRecommendationsRequest The selected questions
     * @param {string} [ifMatch] The current version of this questionnaire
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async questionnairesUpdateQuestionnaire(
      questionnaireId: string,
      selectedRecommendationsRequest: SelectedRecommendationsRequest,
      ifMatch?: string,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PutQuestionsResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.questionnairesUpdateQuestionnaire(
          questionnaireId,
          selectedRecommendationsRequest,
          ifMatch,
          options,
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * You may call this endpoint as many times as you like; it is idempotent. Once in a published state, the questionnaire is locked from further change and cannot be \'un-published\'. This call must be made irrespective if the questionnaire is being attached or not. The response code of this call will indicate whether or not the hirer has chosen any questions to attach to their job advertisement. Both response codes (303 and 204) mean the request to publish was successful.
     * @summary Update Questionnaire to published state
     * @param {string} id The unique id for the Questionnaire being updated
     * @param {PublishRequest} publishRequest The publish request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async questionnairesUpdateQuestionnaireState(
      id: string,
      publishRequest: PublishRequest,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.questionnairesUpdateQuestionnaireState(
          id,
          publishRequest,
          options,
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
  };
};

/**
 * QuestionnairesApi - factory interface
 * @export
 */
export const QuestionnairesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = QuestionnairesApiFp(configuration);
  return {
    /**
     *
     * @summary Creates a questionnaire
     * @param {CreateQuestionnaireRequest} createQuestionnaireRequest Required properties needed to construct the questionnaire
     * @param {boolean} [prefill] If true, the latest answers the hirer has previously used will be automatically selected
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    questionnairesCreateQuestionnaire(
      createQuestionnaireRequest: CreateQuestionnaireRequest,
      prefill?: boolean,
      options?: any,
    ): AxiosPromise<Questionnaire> {
      return localVarFp
        .questionnairesCreateQuestionnaire(
          createQuestionnaireRequest,
          prefill,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Gets a questionnaire
     * @param {string} id The unique id for a questionnaire
     * @param {boolean} [prefill]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    questionnairesGetQuestionnaire(
      id: string,
      prefill?: boolean,
      options?: any,
    ): AxiosPromise<Questionnaire> {
      return localVarFp
        .questionnairesGetQuestionnaire(id, prefill, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get a list of questionnaires
     * @param {string} questionnaireIds Comma-delimited list of questionnaire IDs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    questionnairesGetQuestionnaires(
      questionnaireIds: string,
      options?: any,
    ): AxiosPromise<BatchResponseOfQuestionnaire> {
      return localVarFp
        .questionnairesGetQuestionnaires(questionnaireIds, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Gets a questionnaire\'s questions
     * @param {string} id The unique id for a questionnaire
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    questionnairesGetQuestions(
      id: string,
      options?: any,
    ): AxiosPromise<Array<Question>> {
      return localVarFp
        .questionnairesGetQuestions(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Save a questionnaire
     * @param {string} questionnaireId The unique id for a questionnaire being saved
     * @param {SelectedRecommendationsRequest} selectedRecommendationsRequest The selected questions
     * @param {string} [ifMatch] The current version of this questionnaire
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    questionnairesUpdateQuestionnaire(
      questionnaireId: string,
      selectedRecommendationsRequest: SelectedRecommendationsRequest,
      ifMatch?: string,
      options?: any,
    ): AxiosPromise<PutQuestionsResponse> {
      return localVarFp
        .questionnairesUpdateQuestionnaire(
          questionnaireId,
          selectedRecommendationsRequest,
          ifMatch,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * You may call this endpoint as many times as you like; it is idempotent. Once in a published state, the questionnaire is locked from further change and cannot be \'un-published\'. This call must be made irrespective if the questionnaire is being attached or not. The response code of this call will indicate whether or not the hirer has chosen any questions to attach to their job advertisement. Both response codes (303 and 204) mean the request to publish was successful.
     * @summary Update Questionnaire to published state
     * @param {string} id The unique id for the Questionnaire being updated
     * @param {PublishRequest} publishRequest The publish request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    questionnairesUpdateQuestionnaireState(
      id: string,
      publishRequest: PublishRequest,
      options?: any,
    ): AxiosPromise<void> {
      return localVarFp
        .questionnairesUpdateQuestionnaireState(id, publishRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * QuestionnairesApi - object-oriented interface
 * @export
 * @class QuestionnairesApi
 * @extends {BaseAPI}
 */
export class QuestionnairesApi extends BaseAPI {
  /**
   *
   * @summary Creates a questionnaire
   * @param {CreateQuestionnaireRequest} createQuestionnaireRequest Required properties needed to construct the questionnaire
   * @param {boolean} [prefill] If true, the latest answers the hirer has previously used will be automatically selected
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QuestionnairesApi
   */
  public questionnairesCreateQuestionnaire(
    createQuestionnaireRequest: CreateQuestionnaireRequest,
    prefill?: boolean,
    options?: AxiosRequestConfig,
  ) {
    return QuestionnairesApiFp(this.configuration)
      .questionnairesCreateQuestionnaire(
        createQuestionnaireRequest,
        prefill,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Gets a questionnaire
   * @param {string} id The unique id for a questionnaire
   * @param {boolean} [prefill]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QuestionnairesApi
   */
  public questionnairesGetQuestionnaire(
    id: string,
    prefill?: boolean,
    options?: AxiosRequestConfig,
  ) {
    return QuestionnairesApiFp(this.configuration)
      .questionnairesGetQuestionnaire(id, prefill, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get a list of questionnaires
   * @param {string} questionnaireIds Comma-delimited list of questionnaire IDs
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QuestionnairesApi
   */
  public questionnairesGetQuestionnaires(
    questionnaireIds: string,
    options?: AxiosRequestConfig,
  ) {
    return QuestionnairesApiFp(this.configuration)
      .questionnairesGetQuestionnaires(questionnaireIds, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Gets a questionnaire\'s questions
   * @param {string} id The unique id for a questionnaire
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QuestionnairesApi
   */
  public questionnairesGetQuestions(id: string, options?: AxiosRequestConfig) {
    return QuestionnairesApiFp(this.configuration)
      .questionnairesGetQuestions(id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Save a questionnaire
   * @param {string} questionnaireId The unique id for a questionnaire being saved
   * @param {SelectedRecommendationsRequest} selectedRecommendationsRequest The selected questions
   * @param {string} [ifMatch] The current version of this questionnaire
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QuestionnairesApi
   */
  public questionnairesUpdateQuestionnaire(
    questionnaireId: string,
    selectedRecommendationsRequest: SelectedRecommendationsRequest,
    ifMatch?: string,
    options?: AxiosRequestConfig,
  ) {
    return QuestionnairesApiFp(this.configuration)
      .questionnairesUpdateQuestionnaire(
        questionnaireId,
        selectedRecommendationsRequest,
        ifMatch,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * You may call this endpoint as many times as you like; it is idempotent. Once in a published state, the questionnaire is locked from further change and cannot be \'un-published\'. This call must be made irrespective if the questionnaire is being attached or not. The response code of this call will indicate whether or not the hirer has chosen any questions to attach to their job advertisement. Both response codes (303 and 204) mean the request to publish was successful.
   * @summary Update Questionnaire to published state
   * @param {string} id The unique id for the Questionnaire being updated
   * @param {PublishRequest} publishRequest The publish request
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QuestionnairesApi
   */
  public questionnairesUpdateQuestionnaireState(
    id: string,
    publishRequest: PublishRequest,
    options?: AxiosRequestConfig,
  ) {
    return QuestionnairesApiFp(this.configuration)
      .questionnairesUpdateQuestionnaireState(id, publishRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
